<div
    [style.backgroundImage]="'url(' + teaserCard.imageUri + ')'"
    class="teaser-image"
></div>
<div class="textbox p-24 lg:p-32">
    <h2 [innerHTML]="teaserCard.headline"></h2>
    <p class="m-0 lg:fs:l">{{ teaserCard.content }}</p>
    <div class="price">
        <span class="h3 c:blue-700">
            {{ teaserCard.showPriceFrom ? 'Ab ' : 'Nur ' }}
            <app-display-price [price]="teaserCard.pricePerPeriod"></app-display-price>
            {{ teaserCard.period === 'year' ? 'jährlich' : 'pro Monat' }}
        </span>
        <span class="arrow float:r"></span>
    </div>
</div>
